/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBookmarkMinus = createReactComponent("bookmark-minus", "IconBookmarkMinus", [
  [
    "path",
    { d: "M12 17l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v8", key: "svg-0" }
  ],
  ["path", { d: "M16 19h6", key: "svg-1" }]
]);

export { IconBookmarkMinus as default };
//# sourceMappingURL=IconBookmarkMinus.js.map
